<template>
  <div class="tab-content-presentation">
    <iframe
      v-if="getHackathonSlide"
      :src="`${getHackathonSlide.editorUrl}?presentationId=${presentation.id}&slideId=${slideActive.id}&isPresenting=${isPresenting}`"
      frameborder="0"
      class="edit-iframe"
    ></iframe>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { slideTypes } from '@/constant/slideTypes'

export default {
  components: {
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    getHackathonSlide() {
      const index = slideTypes[0].slideTypes.findIndex((item) => item.slideType === this.slideActive.slideType)
      if (index !== -1) {
        return slideTypes[0].slideTypes[index]
      }
      return null
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-content-presentation {
  padding: 0 !important;
  position: relative;
  z-index: 7; // https://ahaslides.atlassian.net/browse/AHA-14039
  height: 100%;
}
.edit-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
